import Vue from 'vue'
import { Token } from './types'

export const Storage = {
  _get: () => {
    return new Promise<Token>(resolve => {
      const token = localStorage.getItem('token')
      const refresh = localStorage.getItem('refresh')
      if ((!token || !refresh) && window != window.parent) {
        Vue.$postMessage.addEventListener('setSession', args => {
          resolve({
            token: localStorage.getItem('token'),
            refresh: localStorage.getItem('refresh')
          })
        })
        Vue.$postMessage.addEventListener('error', e => {
          console.log(e)
          resolve({ token: null, refresh: null })
        })
        Vue.$postMessage.getSession()
      } else {
        resolve({
          token,
          refresh
        })
      }
    })
  },
  token: async () => {
    const tokens = await Storage._get()
    console.log('%c storage token %c', 'color:green;', '')
    console.log(tokens)
    return tokens.token || ''
  },
  refreshToken: async () => {
    const tokens = await Storage._get()
    console.log('%c storage refresh %c', 'color:green;', '')
    console.log(tokens)
    return tokens.refresh || ''
  }
}
